var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
import { connect } from "react-redux";
import App from "../components/App";
import { logDebugMessage, fetchContent, goToSlide, setKeyValue, deleteKeyValue, setUIVisibilityState, fetchSocialChartData, updateSocialChartData } from "../actions";
import store from "../store";
var initial;
var isKeyMissing = function(key) {
    return !store.getState().keyValueStore.hasOwnProperty(key);
};
var getValForKey = function(key) {
    return isKeyMissing(key) ? {
        error: true,
        msg: 'key "'.concat(key, '" does not exist')
    } : store.getState().keyValueStore[key];
};
var getKeyValStore = function(keys) {
    var isA = Array.isArray(keys);
    if (!isA) {
        keys = [
            keys
        ];
    }
    var values = {};
    keys.filter(function(k) {
        return !isKeyMissing(k);
    }).forEach(function(k) {
        return values[k] = getValForKey(k);
    });
    var missingKeys = keys.filter(function(k) {
        return isKeyMissing(k);
    });
    var invalidKeys = keys.filter(function(k) {
        return typeof k !== "string";
    });
    return !invalidKeys.length ? {
        values: values,
        missingKeys: missingKeys
    } : {
        error: true,
        msg: 'unsupported keys "'.concat(invalidKeys.join(", "), '" - types "').concat(invalidKeys.map(function(k) {
            return typeof k === "undefined" ? "undefined" : _typeof(k);
        }).join(", "), '"')
    };
};
var mapStateToProps = function(state, _ownProps) {
    if (state.currentSlide && !initial) {
        initial = state.currentSlide;
    } else if (initial && initial !== state.currentSlide) {
        initial = "nevermind";
    }
    var status = state.api && state.currentSlide && state.api.getSlideStatus(state.currentSlide);
    return {
        cbook: state.cbook,
        cbookStatus: state.api ? state.api.getCBookStatus() : "",
        connections: state.connections,
        currentSlide: state.currentSlide,
        currentSlideStatus: status && status !== "not attempted" ? status : "incomplete",
        isLoading: !state.api || !state.student || state.loading.indexOf("fetch_cbook") > -1 || state.loading.indexOf("load_api") > -1 || state.loading.indexOf("fetch_locale") > -1 || state.loading.indexOf("fetch_claims") > -1,
        uiVisibilityState: state.uiVisibilityState,
        storyMode: state.storyMode,
        student: state.student,
        getSlide: function(id) {
            return state.nodes.find(function(n) {
                return n.id === id;
            });
        },
        contents: state.contents,
        searchableSlides: state.searchableSlides,
        getKeyValStore: getKeyValStore,
        isInitialChart: state.currentSlide === initial,
        completeable: state.completeable,
        session: state.session,
        socialConfig: state.socialConfig
    };
};
var mapDispatchToProps = function(dispatch, ownProps) {
    return {
        setVisibilityState: function(state) {
            dispatch(setUIVisibilityState({
                state: state
            }));
        },
        fetchContent: function(id, nodeType, nodeId) {
            dispatch(fetchContent({
                id: id,
                nodeType: nodeType,
                nodeId: nodeId
            }));
        },
        sendDebugMessage: function(message, messageType, label) {
            dispatch(logDebugMessage({
                message: message,
                messageType: messageType,
                label: label
            }));
        },
        goTo: function(id, localId, origin) {
            dispatch(goToSlide({
                id: id,
                localId: localId,
                origin: origin
            }));
        },
        setKeyVal: function(key, value) {
            dispatch(setKeyValue({
                key: key,
                value: value
            }));
            return value;
        },
        deleteKey: function(key) {
            dispatch(deleteKeyValue({
                key: key
            }));
            return true;
        },
        fetchSocialChartData: function(node_id, plugin_id) {
            dispatch(fetchSocialChartData({
                node_id: node_id,
                plugin_id: plugin_id
            }));
        },
        updateSocialChartData: function(node_id, plugin_id, socialChartData) {
            dispatch(updateSocialChartData({
                node_id: node_id,
                plugin_id: plugin_id,
                socialChartData: socialChartData
            }));
        },
        fetchCommunityChartData: function(nodeId, pluginId) {
            dispatch(fetchSocialChartData({
                nodeId: nodeId,
                pluginId: pluginId
            }));
        }
    };
};
// export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(App))
export default connect(mapStateToProps, mapDispatchToProps)(App);
